import { Auth } from 'aws-amplify';

import { isGenuineAuthInvalidationError } from './isGenuineAuthInvalidationError';

let reauthFlowPromise: Promise<void> | null = null;

// Re-checks the session after the sync layer ran into an auth error mid-session, and signs the user
// out if it turns out there is no usable session left. Deliberately never rejects: callers fire it
// and move on, and a transient failure here is nothing they can act on - a rejection would only
// ever surface as an unhandled one. Concurrent calls share a single in-flight check.
export async function initReauthFlow(): Promise<void> {
    if (!reauthFlowPromise) {
        reauthFlowPromise = (async () => {
            try {
                // currentUserPoolUser() rather than currentAuthenticatedUser(), which collapses
                // every failure into one generic string and so leaves nothing to classify -
                // see the comment in Reauthenticate.ts.
                await Auth.currentUserPoolUser();
            } catch (error) {
                if (isGenuineAuthInvalidationError(error)) {
                    // A full sign out rather than dispatching the sign-out actions directly, so
                    // that the single cleanup path (Hub 'signOut' in WithAuthenticatedUser: local
                    // database wipe, impersonation record, preferred environment) runs and
                    // Amplify's own cached tokens go with it.
                    await Auth.signOut();

                    return;
                }
                console.error('Could not verify the session, leaving it as it is: ', error);
            }
        })().catch((error: unknown) => {
            console.error('Reauth flow failed unexpectedly: ', error);
        });
        reauthFlowPromise.finally(() => {
            reauthFlowPromise = null;
        });
    }

    return reauthFlowPromise;
}
